module.exports = __webpack_public_path__ + "zendesk-2-eca95890bfd8113f61b3389cd60a5cf8.webp";